import { getDefaultHeight, SVG } from "./utils";

type Props = React.SVGProps<SVGSVGElement>;

export const MicrosoftWordIcon: React.FC<Props> = (svgProps) => {
  return (
    <SVG
      viewBox="0 0 1052 1052"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 1052)}
      {...svgProps}
    >
      <path
        fill="#fff"
        d="M526 125.2h475.9a25 25 0 0 1 25 25v751.4a25 25 0 0 1-25 25H526a25 25 0 0 1-25-25V150.3a25 25 0 0 1 25-25.1z"
      />
      <path
        fill="#2b579a"
        d="M1001.9 150.3v751.4H526V150.3h475.9m0-50.1H526a50 50 0 0 0-50.1 50.1v751.4a50 50 0 0 0 50.1 50.1h475.9a50 50 0 0 0 50.1-50.1V150.3a50 50 0 0 0-50.1-50.1z"
      />
      <path
        fill="#2b579a"
        d="M601.1 250.5h300.6v50.1H601.1zM601.1 350.7h300.6v50.1H601.1zM601.1 450.9h300.6V501H601.1zM601.1 551h300.6v50.1H601.1zM601.1 651.2h300.6v50.1H601.1zM601.1 751.4h300.6v50.1H601.1z"
      />
      <path
        d="M626.2 0 0 109.7v832.6L626.2 1052V0z"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#2b579a" }}
      />
      <path
        fill="#fff"
        d="m501 350.7-72.4 4.5-53.3 258.3-41.6-253.3-68.6 4.3-53.6 252.7L162.6 371l-62.4 4.8 66.6 335.6 69.4 4.3L288.3 472l48.6 249 75.1 4.5 89-374.8"
      />
    </SVG>
  );
};
